import { createContext, Dispatch, SetStateAction, useContext } from 'react'
import { TIntegrationItem } from '../types'

export type TIntegrationContext = {
 fbIntegrationData?: TIntegrationItem[]
 setFbIntegrationData?: Dispatch<SetStateAction<TIntegrationItem[]>>
 onDisconnectFb?: (page_id?: any, isMultiple?: boolean) => void
}

export const IntegrationContext = createContext<TIntegrationContext>({})

export const useIntegrationContext = () => useContext(IntegrationContext)
